module.exports = __webpack_public_path__ + "img/0020_sensitivity.18c79dce.jpg";